const PICKUP_MANAGEMENT_MODES = {
  CREATE_PICKUP: "createPickup",
  EDIT_PICKUP: "editPickup",
  VOID_PICKUP: "voidPickup",
  UNVOID_PICKUP: "unvoidPickup",
  MERGE_PICKUP: "mergePickup",
  NO_FREIGHT_PICKUP: 'noFreightPickup',
  UNGROUP_PICKUP: 'unGroupPickup',
  BULK_EDIT_PICKUP: 'bulkEditPickup',
  BULK_VOID_PICKUP: 'bulkVoidPickup',
};

const PICKUP_MANAGEMENT_BILLING_MODES = [
  PICKUP_MANAGEMENT_MODES.CREATE_PICKUP,
  PICKUP_MANAGEMENT_MODES.EDIT_PICKUP,
  PICKUP_MANAGEMENT_MODES.BULK_EDIT_PICKUP,
  PICKUP_MANAGEMENT_MODES.BULK_VOID_PICKUP,
  PICKUP_MANAGEMENT_MODES.VOID_PICKUP,
  PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP,
  PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP,
];

const BULK_VOID_DISCLAIMER_MSG = "All the pickups in the group will be voided.";
const VOID_UNASSIGN_SINGLE_MESSAGE = "Please unassign the pickup before voiding.";
const VOID_UNASSIGN_BULK_GROUP_MESSAGE =
  "Please unassign the group pickups before voiding.";
const VOID_UNASSIGN_GROUPED_HELPER_MESSAGE =
  "All pickups in the group will be unassigned together. To unassign only selected ones, ungroup the pickup first.";

const MAX_LENGTH_CONSTRAINTS = {
  CREATE_PICKUP_FORM: {
    ACCOUNT: 30,
    SHIPPER_ADDRESS1: 30,
    SHIPPER_ADDRESS2: 30,
    SHIPPER_CITY: 20,
    SHIPPER_STATE: 2,
    SHIPPER_ZIP: 6,
    SHIPPER_CONTACT_NAME: 30,
    SHIPPER_CONTACT_PHONE: 10,
    SHIPPER_ADDRESS: 30,
    BILL_TO_CODE: 7,
    BILL_TO_NAME: 20,
    QUOTE_NUMBER: 11,
    REFERENCE_NUMBER: 20,
    SPECIAL_INSTRUCTIONS: 3000,
    DESTINATION_ZIP: 6,
    PIECES: 5,
    WEIGHT: 7,
    HU: 5,
    ROUTE : 6,
    RESERVATION_REQUESTOR_TEXT: 100,
    RESERVATION_REQUESTOR_PHONE_INPUT: 14,
    RESERVATION_REQUESTOR_EMAIL: 254,
  },
  VOID_PICKUP_FORM: {
    COMMENT: 300
  }
};

const MIN_LENGTH_CONSTRAINTS = {
  CREATE_PICKUP_FORM: {
    SHIPPER_NAME : 3,
    DESTINATION_ZIP: 5,
    SHIPPER_ADDRESS: 3,
    SHIPPER_ACCOUNT: 7
  }
}

const MAX_VALUE_CONSTRAINTS = {
  CREATE_PICKUP_FORM: {
    SHIPPER_ZIP: 999999,
    PRO_NUMBER: 999999999999,
    DESTINATION_ZIP: 999999,
    PIECES: 99999,
    WEIGHT: 9999999,
    HU: 99999,
    HAZMAT_WEIGHT: 999999,
    EXCESSIVE_LENGTH: 99,
  },
};

const MIN_VALUE = {
  CREATE_PICKUP_FORM: {
    WEIGHT: 1,
    PIECES: 1,
    EXCESSIVE_LENGTH: 1,
    HU: 1,
  },
  DEFAULT: 0,
};

const FORM_VALIDATION_MSG = {
  REQUIRED: "* Required",
  INVALID_PHONE_NUMBER: "Invalid phone number",
  PHONE_TEN_DIGITS: "Must be 10 digits",
  INVALID_EMAIL: "Invalid email",
  MIN_PICKUP_DATE:
    "Pickup date should not be less than in selected terminal's current date",
  MAX_PICKUP_DATE: "Pickup date cannot be more than 7 days in future",
  HU: {
    REQUIRED: "* HU is required",
    INVALID_MAX_VALUE: "* HU max value exceeded",
    INVALID_MIN_VALUE: "* HU min value violated",
  },
  PIECES: {
    REQUIRED: "* Pieces is required",
    INVALID_MAX_VALUE: "* Pieces max value exceeded",
    INVALID_MIN_VALUE: "* Pieces min value violated",
  },
  WEIGHT: {
    REQUIRED: "* Weight is required",
    INVALID_MAX_VALUE: "* Weight max value exceeded",
    INVALID_MIN_VALUE: "* Weight min value violated",
  },
  ZIP_CODE: {
    REQUIRED: "* Zip Code is required",
    INVALID_MAX_VALUE: "* Zip Code max value exceeded",
    INVALID_VALUE: "* Invalid Zip Code",
  },
  PACKAGE_CODE: {
    REQUIRED: "* Package Code is required",
  },
  SEARCH_FIELD_ERROR: {
    TERMINAL_REQUIRED: "Select a terminal to search shipper",
  },
  MERGE_PICKUP_DRIVER_ARRIVED_SHIPPER_LOC : 
    "Pickups cannot be merged when the driver is arrived at the shipper location"
};

export const SEARCH_TYPE = {
  NAME: "name",
  ACCOUNT_CODE: "accountCode",
  PHONE: "phone",
  ADDRESS: "address"
}

const SEARCH_FILTER_OPTIONS = [
  {
    label: "Name",
    value: SEARCH_TYPE.NAME,
  },
  {
    label: "Account Code",
    value: SEARCH_TYPE.ACCOUNT_CODE,
  },
  {
    label: "Phone #",
    value: SEARCH_TYPE.PHONE,
  },
  {
    label: "Address",
    value: SEARCH_TYPE.ADDRESS,
  },
];

const WARNING_DETAILS= {
  DESTINATION_LABEL: "Destination Warning",
  SHIPPER_LABEL: "Shipper Warning",
  DESTINATION_DESCRIPTION: "Do not accept shipment unless the customer can provide a valid Saia Account code number.",
  SHIPPER_DESCRIPTION: "Do not accept shipment unless the customer can provide a valid Saia Account code number.",
  WARNING_LABELS: {
    CREATE: "Continue create pickup",
    EDIT: "Continue edit pickup",
    MERGE: "Continue merge pickup",
  }
}

const ORDERERD_FIELD_LIST = [
  "shipperContactPhone",
  "shipperEmail",
  "shipperName",
  "shipperZip",
  "shipperAddress1",
  "swapAndDrop",
  "readyTime",
  "closeTime",
  "pickupDate",
  "dispatchZone",
  "editReasonCode",
  "noFreightPickup",
  "noFreightCode",
  "contactName",
  "callTime",
  "comments",
  "requestorName",
  "requestorCompany",
  "requestorPhone",
  "requestorEmail",
]

const ZONE_OPTIONS = ["0","1","2","3","4","5","6","7","8"];

export {
  MAX_LENGTH_CONSTRAINTS,
  MIN_VALUE,
  MAX_VALUE_CONSTRAINTS,
  FORM_VALIDATION_MSG,
  PICKUP_MANAGEMENT_MODES,
  PICKUP_MANAGEMENT_BILLING_MODES,
  SEARCH_FILTER_OPTIONS,
  WARNING_DETAILS,
  ORDERERD_FIELD_LIST,
  MIN_LENGTH_CONSTRAINTS,
  ZONE_OPTIONS,
  BULK_VOID_DISCLAIMER_MSG,
  VOID_UNASSIGN_SINGLE_MESSAGE,
  VOID_UNASSIGN_BULK_GROUP_MESSAGE,
  VOID_UNASSIGN_GROUPED_HELPER_MESSAGE,
};
